import CrudPage from "./CrudPage";

const Teachers = () => (
  <CrudPage
    title="Lehrpersonen"
    resource="teachers"
    testId="admin-teachers"
    columns={[
      { key: "name", label: "Name" },
      { key: "department", label: "Fachbereich" },
      { key: "role", label: "Rolle" },
      { key: "voluntary", label: "Ehrenamtlich", format: v => v ? "Ja" : "Nein" },
      { key: "share_per_student", label: "Anteil CHF", format: v => `CHF ${v ?? 0}` },
    ]}
    fields={[
      { key: "name", label: "Name", required: true },
      { key: "email", label: "E-Mail", type: "email" },
      { key: "phone", label: "Telefon" },
      { key: "department", label: "Fachbereich", required: true },
      { key: "role", label: "Rolle" },
      { key: "voluntary", label: "Ehrenamtlich", type: "boolean" },
      { key: "payout_active", label: "Auszahlung aktiv", type: "boolean" },
      { key: "share_per_student", label: "Anteil CHF pro Lektion", type: "number" },
      { key: "education", label: "Ausbildung", full: true },
      { key: "experience", label: "Erfahrung" },
      { key: "languages", label: "Sprachen (Komma)", type: "list" },
      { key: "photo", label: "Foto URL", full: true },
      { key: "bio", label: "Biografie", type: "textarea", full: true },
    ]}
    defaults={{ name: "", email: "", phone: "", department: "", role: "Lehrperson", voluntary: false, payout_active: true, share_per_student: 0, education: "", experience: "", languages: [], photo: "", bio: "" }}
  />
);

export default Teachers;
